import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import type { Destination } from '@/features/destinations/utils/Destination';
import useAppointmentStore from '@/store/AppointmentStore';
import { FlowType } from '@/types/FlowType';

const buildAppointmentPath = (flow: FlowType, workTypeId: string) =>
  flow === FlowType.EMAIL
    ? `/email-inquiry/${workTypeId}/contact-info`
    : `/schedule-appointment/${workTypeId}`;

const useProceedWithDestination = (flow: FlowType) => {
  const selectedDestination = useAppointmentStore(
    (state) => state.selectedDestination,
  );
  const navigate = useNavigate();

  return useCallback(
    (destination?: Destination) => {
      const workTypeId =
        destination?.workTypeId || selectedDestination.workTypeId;
      if (!workTypeId) return;
      navigate(buildAppointmentPath(flow, workTypeId));
    },
    [flow, navigate, selectedDestination.workTypeId],
  );
};

export default useProceedWithDestination;
